// axiosInstance.js
import axios, { AxiosInstance } from 'axios';
import { API_ENDPOINTS } from 'utils/constants';

const baseURL = API_ENDPOINTS.baseURL || 'https://test.api.identityguard.com/';

/**
 * Axios instance for making API requests.
 * @type {import("axios").AxiosInstance}
 */
const api: AxiosInstance = axios.create({
  baseURL,
  timeout: 50000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en-US',
  },
});

export default api;
